import { LazyLoadedStatesManager } from '../class/lazy-loaded-states-manager.class';
import { LazyLoadedStates } from '../interfaces/lazy-loaded-states.interface';

export const PermissionsLazyLoadedStates = new LazyLoadedStatesManager<{ 
    base: LazyLoadedStates,
    editPermissions: LazyLoadedStates,
    permissionSettings: LazyLoadedStates,
}> ({
    base: {
        name: 'authenticated.permissions',
        url: '/permissions',
        abstract: true
    },
    editPermissions: {
        name: 'authenticated.permissions.edit',
        url: '/edit'
    },
    permissionSettings: {
        name: 'authenticated.permissions.permissionSettings',
        url: '/permissionSettings?roleIds&portalId',
        params: {
            roleIds: {
                raw: true,
                type: 'int',
                array: true,
                value: []
            },
            portalId: {
                raw: true,
                type: 'int'
            }
        }
    }
}, 
() => import('src/app/permissions/permissions.module').then((result: {PermissionsModule: any}) => result.PermissionsModule)
);
